import { render, staticRenderFns } from "./ConvoyWagonSelectionManagement.vue?vue&type=template&id=489b3974&scoped=true&"
import script from "./ConvoyWagonSelectionManagement.vue?vue&type=script&lang=js&"
export * from "./ConvoyWagonSelectionManagement.vue?vue&type=script&lang=js&"
import style0 from "./ConvoyWagonSelectionManagement.vue?vue&type=style&index=0&id=489b3974&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489b3974",
  null
  
)

export default component.exports